export default __webpack_public_path__ + "static/media/scho_digiticon.69a6a8ff.svg";